export default [
  {
    path: '/kys-dof/dof',
    name: 'kys-dof-dof',
    component: () => import('./Index.vue'),
    meta: {
      public: false,
      title: "kys_dof.Dof_Listesi",
      yetki: { k: [1190002] },
    },
  },
  {
    path: '/kys-dof/dof/ekle',
    name: 'kys-dof-dof-ekle',
    component: () => import('./DofCreate.vue'),
    meta: {
      public: false,
      title: "kys_dof.Yeni_Dof",
      yetki: { k: [1190003] },
    },
  },
  {
    path: '/kys-dof/dof/:uuid',
    name: 'kys-dof-dof-detay',
    component: () => import('./DofDetail.vue'),
    meta: {
      public: false,
      title: "kys_dof.Dof_Detay",
      yetki: { k: [1190002] },
    },
  },
]
